module.exports = __webpack_public_path__ + "img/icagile-icp.6a5fe4cf.png";